import { atom } from 'recoil';
import { FilterDef } from '../../../../constants/FinanceModels';

export const STATE_TABLE_UPDATING = atom<boolean>({
    key: "sdd-mandates-state-table-updating",
    default: false
});

export const STATE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'sdd-mandates-state-active-filters',
    default: []
});